import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface IBotaoVoltarProps extends RouteComponentProps {
  titulo: string;
  url?: string;
}

class BotaoVoltar extends React.Component<IBotaoVoltarProps, {}> {
  render(): any {
    let { titulo, url } = this.props;

    return (
      <p className="title">
        {url && (
          <i
            className="fas fa-chevron-left"
            onClick={this.props.history.goBack}
          ></i>
        )}
        {!url && (
          <i
            className="fas fa-chevron-left"
            onClick={this.props.history.goBack}
          ></i>
        )}
        &nbsp;&nbsp; {titulo}
      </p>
    );
  }
}

export default withRouter(BotaoVoltar);
